<template>
    <section>
        <div class="container container-app">
            <div class="row">
                <div class="col-12 mt-5 text-center">
                    <img style="width: 330px;" src="./../../assets/404.svg" alt="404" />
                </div>
                <div class="col-12 text-center">
                    <h1 class="notfound-title">{{ $t('not_found.404') }}</h1>
                    <span class="notfound-label">{{ $t('not_found.page_not_found') }}</span>
                </div>
                <div class="col-4 mt-3">
                </div>
                <div class="mt-3 col-4">
                    <button @click.prevent="goto('home', {})" class="w-100 btn btn-secondary notfound-button">{{ $t('not_found.back') }}</button>
                </div>
                <div class="col-4 mt-3">
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import HelperMixin from "../../mixins/HelperMixin";

    export default {
        name: "notFound",
        mixins: [HelperMixin],
        data() {
            return {
                
            }
        },
        created() {
            
        },
        mounted() {
        },
        computed: {
            
        },
        methods: {

        },
    };
</script>
